export class Messenger {
  constructor(messageManager) {
    this.manager = null;
    this.messageManager = messageManager;
  }

  async addListener(type, fn) {
    this.callManager('addListener', [type, fn]);
  }

  sendMessage(type, content) {
    this.callManager('sendMessage', [type, content]);
  }

  receiveMessage(type, content) {
    this.callManager('receiveMessage', [type, content]);
  }

  deleteListener(type) {
    this.callManager('deleteListener', type);
  }

  async callManager(fn, data) {
    if (!this.manager) {
      this.manager = await this.messageManager;
    }
    this.manager[fn](...data);
  }
}
